module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-insider-563ff37b9b6d9cd049f23e30669d5d6d.svg";